import customAreaPointDataFromJson from "../custom_area_point/mapper";
import CustomAreaData from "./data";

export default function customAreaDataFromJson(json) {
  return new CustomAreaData(
    json.id,
    json.theyr_id,
    json.area_points.map((point) => customAreaPointDataFromJson(point)),
    json.description,
    json.created_at,
    json.lastUsedDate
  );
}
